// Not-found fallback (spec #31 — INTERNAL_ERROR + 404 on the server).
import { Link } from 'react-router-dom';

export function NotFoundScreen() {
  return (
    <div className="empty">
      <h2>Page not found</h2>
      <p className="muted">The page you were looking for does not exist.</p>
      <Link to="/home" className="btn btn--primary">
        Go home
      </Link>
    </div>
  );
}
